import { get, post } from '../util/axios'

export default class Model {
  static async getQuestionGroup(data) {
    return await get('api/v1/poetry/get/poetry_group', data)
  }

  static async getPoetryDetail(data) {
    return await get('api/v1/poetry/get/poetry', data)
  }

  static async getRanking() {
    return await get('api/v1/game/get/ranking')
  }

  static async getStageList() {
    return await get('api/v1/user/get/stage_range')
  }

  static async setRange(data) {
    return await post('api/v1/user/set/stage_range', data)
  }

  static async createRoom(data) {
    return await post('api/v1/game/create/game_room', data)
  }

  static async getPkInfo() {
    return await get('api/v1/user/get/game_info')
  }

  static async getUserinfo() {
    return await get('api/v1/user/get/user_info')
  }

  static async buy(data) {
    return await post('api/v1/prop/buy/power', data)
  }

  static async getPropertyInfo() {
    return await get('api/v1/user/get/property_info')
  }

  static async getGameReview(data) {
    return await get('api/v1/game/game_review', data)
  }

  static async updateUserinfo(data) {
    return await post('api/v1/user/update/user_info', data)
  }

  static async getUserList() {
    return await get('api/v1/game/get/user_online_list')
  }

  static async createMatchRoom(data) {
    return await post('/api/v1/game/create/match/game_room', data)
  }

}